import { getContractABI, getContractAddress } from "../utils/abiHelper";
import { getWeb3IfAvailable, parseError, toRealNumber } from "../web3Utils";
import { ContractService } from "./ContractService";
import axios from "axios";

export class BinanceMysteryBoxService extends ContractService {

    constructor(args = {}) {
        super();
        this.contractType = 'BinanceMysteryBox'
        this.abi = getContractABI(this.contractType);
        this.addHooks();
    }

    async preHook() {
        this.web3 = await getWeb3IfAvailable()
        this.accounts = await this.web3.eth.getAccounts();
        this.contractAddress = await getContractAddress(this.contractType);
        this.contractInstance = new this.web3.eth.Contract(
            this.abi,
            this.contractAddress
        );
    }


    async balanceOf() {
        try{
            const balance = await this.contractInstance.methods.balanceOf(this.accounts[0]).call();
            return toRealNumber(balance);
        } catch(err) {
            throw parseError(err);
        }
    }

    async tokenOfOwnerByIndex( userAddress, index) {
        try{
            const tokenId = await this.contractInstance.methods.tokenOfOwnerByIndex(userAddress, index).call();
            return tokenId;
        } catch(err) {
            throw parseError(err);
        }
    }

    async tokenURI(tokenId) {
        try{
            const tokenURI = await this.contractInstance.methods.tokenURI(tokenId).call();
            return tokenURI;
        } catch(err) {
            throw parseError(err);
        }
    }

    async getAll({
        limit = 10,
        skip = 0
    }) {

        try {

            const tokenIdsMap = new Map();

            const tokenIds = await Promise.allSettled(
                Array(limit)
                .fill(0)
                .map(( _, index) => {
                    tokenIdsMap.set( index, {});
                    return this.tokenOfOwnerByIndex(
                        this.accounts[0],
                        skip + index 
                    )
                })
            );

            const tokenURIs = await Promise.allSettled(
                tokenIds
                .map((tokenId, index) => {
                    const tokenIdInfo = tokenIdsMap.get( index );
                    if(tokenId.value) {
                        tokenIdsMap.set( index, { ...tokenIdInfo, tokenId: tokenId.value });
                        return this.tokenURI(tokenId.value);
                    }
                    return Promise.resolve();
                })
            );

            // const nfts = await Promise.allSettled(
            //     tokenURIs
            //     .map((tokenURI, index) => {
            //         const tokenIdInfo = tokenIdsMap.get( index );
            //         if(tokenURI.value) {
            //             tokenIdsMap.set( index, { ...tokenIdInfo, tokenURI: tokenURI.value });
            //             return axios.get(tokenURI.value)
            //         }
            //         return Promise.resolve();
            //     })
            // );

            // for(let index = 0; index < nfts.length; index++) {
            //     const tokenIdInfo = tokenIdsMap.get( index );
            //     if(nfts[index].value) {
            //         tokenIdsMap.set( index, { ...tokenIdInfo, ...nfts[index].value.data });
            //     }
            // }

            return [...tokenIdsMap.values()].filter((resp) => resp.tokenId);
         } catch(err) {
             console.log('Caught error while fetching NFTs', err)
            throw parseError(err);
        }
    }

    async isApprovedForAll(
        ownerAddress = this.accounts[0],
        spenderAddress
    ) {
        try{
            const hasApprovalForAll = await this.contractInstance
                .methods
                .isApprovedForAll(ownerAddress, spenderAddress)
                .call();
            return Boolean(hasApprovalForAll);
        } catch(err) {
            throw parseError(err);
        }
    }

    async setApprovalForAll(
        spenderAddress,
        value = true
    ) {

        try {
            const gasPrice = await this.web3.eth.getGasPrice();

            let options = {
                gasPrice,
                from: this.accounts[0]
            };

            const estimatedGas = await this.contractInstance.methods
                .setApprovalForAll(
                    spenderAddress,
                    value
                )
                .estimateGas(options);
             
            options['gas'] = estimatedGas + 5000;
            await this.contractInstance
                .methods
                .setApprovalForAll(
                    spenderAddress,
                    value
                )
                .send(options);
        } catch(err) {
            throw parseError(err);
        }

        return 'NFTs approval processed successfully!';
    }
    
}